require('../../../public/javascripts/jquery/jquery.iframe-transport.js')
require('../../../public/javascripts/jquery/ui/jquery.ui.widget.js')
require('../../../public/javascripts/jquery/jquery.fileupload.js')
require('../../../public/javascripts/strftime.js')
require('../../../public/javascripts/templates/photos.js')
require('expose?rwgpsG_views_photos!../../../public/javascripts/rwgps/views/photos.js')



// WEBPACK FOOTER //
// ./app/assets/javascripts/photos_view.js